export default __webpack_public_path__ + "static/media/background.4cc54e3e.webp";